<template>
  <div>
    <section>
      <template>
        <v-container fluid>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <v-skeleton-loader
                v-if="helpers.dataIsLoading"
                elevation="2"
                type="table-heading, table-tbody"
              ></v-skeleton-loader>
              <v-card v-else>
                <personnel-record-deadlines-data-table
                  :deadlines="deadlinesCache?.entries || []"
                  showDeadline
                  showHistory
                  showDocuments
                  allowGrouping
                  allowGroupingByDeadline
                  allowGroupingByStatus
                ></personnel-record-deadlines-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
  </div>
</template>

<script>
import { db } from "@/firebase";
import PersonnelRecordDeadlinesDataTable from "@/components/member-management/personnel-records/PersonnelRecordDeadlinesDataTable.vue";
export default {
  name: "member-management-personnel-records-details-physicals",
  components: {
    PersonnelRecordDeadlinesDataTable,
  },
  props: {
    personnelRecord: Object,
    propPersonnelRecordId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      helpers: {
        dataIsLoading: true,
      },
      deadlinesCache: null,
    };
  },
  computed: {
    // Use prop ID if available (split screen mode), otherwise fall back to route param
    personnelRecordId() {
      return this.propPersonnelRecordId || this.$route.params.itemId;
    },
  },
  watch: {
    $route: "initialize",
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getDeadlineEntries();
    },
    getDeadlineEntries() {
      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("personnelRecords_deadlineEntry")
        .doc(this.personnelRecordId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.deadlinesCache = doc.data();
          } else {
            console.log("No deadline cache document found for this user.");
          }
        })
        .catch((error) => {
          console.error("Error getting deadline cache:", error);
        })
        .finally(() => {
          this.helpers.dataIsLoading = false;
        });
    },
  },
};
</script>

<style></style>
